/**
 * Dashboard store
 * Tracks sites list for the VS Code dashboard extension
 */
import { computed, signal } from '@lit-labs/signals';
const statusSignal = signal('idle');
const sitesSignal = signal([]);
const lastUpdatedSignal = signal(null);
const errorMessageSignal = signal(null);
const dfRepoStatusSignal = signal(undefined);
const appsSignal = signal([]);
export const dashboardState = computed(() => ({
    status: statusSignal.get(),
    sites: sitesSignal.get(),
    lastUpdated: lastUpdatedSignal.get(),
    errorMessage: errorMessageSignal.get(),
    dfRepoStatus: dfRepoStatusSignal.get(),
    apps: appsSignal.get(),
}));
export function setDashboardLoading() {
    statusSignal.set('loading');
    errorMessageSignal.set(null);
}
export function setDashboardSites(sites, lastUpdated, dfRepoStatus, apps) {
    sitesSignal.set(sites);
    statusSignal.set('ready');
    errorMessageSignal.set(null);
    lastUpdatedSignal.set(lastUpdated ?? Date.now());
    if (dfRepoStatus) {
        dfRepoStatusSignal.set(dfRepoStatus);
    }
    if (apps) {
        appsSignal.set(apps);
    }
}
export function setDashboardError(message) {
    statusSignal.set('error');
    errorMessageSignal.set(message);
    lastUpdatedSignal.set(Date.now());
}
export function resetDashboardState() {
    statusSignal.set('idle');
    sitesSignal.set([]);
    lastUpdatedSignal.set(null);
    errorMessageSignal.set(null);
    appsSignal.set([]);
}
//# sourceMappingURL=dashboard.store.js.map